import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useFollow(stockCodeSlug) {
  const common = slug => ({ url: `/api/v1/stock_code/${slug}/follow` });
  const [state, q] = useAxios({ ...common(stockCodeSlug), method: 'POST' }, { manual: true });
  const executeQuery = slug => q(common(slug));
  return [state, executeQuery];
}

export function useUnfollow(stockCodeSlug) {
  const common = slug => ({ url: `/api/v1/stock_code/${slug}/unfollow` });
  const [state, q] = useAxios({ ...common(stockCodeSlug), method: 'POST' }, { manual: true });
  const executeQuery = slug => q(common(slug));
  return [state, executeQuery];
}
